import { createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { ProfileStoreInterface } from '../types';

export default createSlice({
  name: REDUX_STORE_SLICES.PROFILE,
  initialState: {
    profile: null,
  },
  reducers: {
    setProfile: (state: ProfileStoreInterface, action) => {
      state.profile = action.payload;
    },
  },
});

export const props = (state: ProfileStoreInterface) => state;
